import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_BLUE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_EYEBROW } from '../styles/typography/typography';
export var SMALL_STAR_WIDTH = 24;
export var MEDIUM_STAR_WIDTH = 32;
export var LARGE_STAR_WIDTH = 40;
export var RatingContainer = styled('div')({
  '&.EmbersRating-root': {
    position: 'relative',
    display: 'flex',
    columnGap: '11px',
    alignItems: 'center',
    cursor: 'pointer',
    '&.EmbersRating-readOnly': {
      cursor: 'default',
      '.EmbersRating-icon': {
        border: 'none',
        justifyContent: 'flex-start'
      }
    },
    '&.EmbersRating-disabled': {
      cursor: 'default'
    },
    '.EmbersRating-Wrapper:focus-visible': {
      '.EmbersRating-icon': {
        '&.EmbersRating-hasFocus': {
          borderColor: PROMETHEAN_BLUE,
          pointerEvent: 'none'
        }
      }
    },
    '.EmberRating-label': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
      userSelect: 'none',
      '&.label-left': {
        order: -1
      },
      '&.label-right': {
        order: 0
      },
      '&.count-label': {
        position: 'relative'
      }
    }),
    '.EmbersRating-star': {
      lineHeight: 1
    },
    '&.EmbersRating-small': {
      '.count-label': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW), {}, {
        top: 3
      }),
      '.EmbersRating-Wrapper': {
        height: SMALL_STAR_WIDTH
      },
      '.EmbersRating-icon': {
        height: SMALL_STAR_WIDTH,
        width: SMALL_STAR_WIDTH,
        '.EmbersRating-star': {
          fontSize: SMALL_STAR_WIDTH + 'px',
          height: SMALL_STAR_WIDTH
        }
      }
    },
    '&.EmbersRating-medium': {
      '.count-label': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
        top: 5
      }),
      '.EmbersRating-Wrapper': {
        height: MEDIUM_STAR_WIDTH
      },
      '.EmbersRating-icon': {
        height: MEDIUM_STAR_WIDTH,
        width: MEDIUM_STAR_WIDTH,
        '.EmbersRating-star': {
          fontSize: MEDIUM_STAR_WIDTH + 'px',
          height: MEDIUM_STAR_WIDTH
        }
      }
    },
    '&.EmbersRating-large': {
      '.EmbersRating-Wrapper': {
        height: LARGE_STAR_WIDTH
      },
      '.EmbersRating-icon': {
        height: LARGE_STAR_WIDTH,
        width: LARGE_STAR_WIDTH,
        '.EmbersRating-star': {
          fontSize: LARGE_STAR_WIDTH + 'px',
          height: LARGE_STAR_WIDTH
        }
      }
    }
  }
});
export var RatingIcon = styled('div')({
  '&.EmbersRating-icon': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: '2px solid transparent',
    '&.EmbersRating-half > .EmbersRating-star': {
      '&.EmbersRating-starEmpty': {
        position: 'absolute'
      },
      '&.EmbersRating-starFill': {
        width: '50%',
        overflow: 'hidden'
      }
    }
  }
});